<template>
  <v-app
    class='white'
    light
  >
    <v-content>
     <sHeader title='My Genetic Trust Survey'/>
      <section>
        <v-layout
          row
          wrap
          align-center
          class="my-12"
        >

          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout
                row
                align-center
              >
              <v-flex
                xs12
                md8
               class="text-center"
              >
              <v-card
                flat
                class="transparent"
              >
                                   <p class='font-weight-regular title'>
                                      Please let us know about your experience using the Genetic Trust.
                                    </p>
                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md6
                 class="text-right"
                >
                  <v-card
                    flat
                    class="transparent"
                  >

                    <v-card-text>
                      <p class='font-weight-regular title'>
                        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfGINnwzIz58wXocsOSCbVDiOXxIe_UUwakWiNfOASIM51qCw/viewform?embedded=true" width="100%" height="1300" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                      </p>

                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-card
                    flat
                    class="transparent"
                  >
                    <v-card-text class="text-center topalign">
                      <img src='../../assets/staticAsset/GSF_InitialStyleSketches-scientist-green.png' />
                    </v-card-text>
                    <v-card-text>
                      <p class="title font-weight-bold mainBlue">Looking for More?</p>
                      <p class='font-weight-medium title'>
                       If you're looking for more information and support, visit our parent foundation at
                      <a style='color:#399342' href='https://www.geneticsupportfoundation.org'>GeneticSupportFoundation.org</a>.
                      </p>
                    </v-card-text>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-container>
          </v-flex>
              </v-layout>

      </section>

      <!-- footer section -->
      <v-footer
        class='footer white'
        color="darken-2"
      >
     <sfooter />
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
import sHeader from "../../components/staticPage/Header"
import signupButton from "../../components/Signup"
import sfooter from "../../components/staticPage/Footer"
export default {
    components : {
    sfooter,
    signupButton,
    sHeader
  },
  mounted () {
  }
}
</script>

<style scoped>
.mainBlue {
  color: #399342;
}
.featureCard{
  margin-bottom : 1%
}
p {
font-weight : bold
}
.topalign {
  vertical-align: text-top;
}
</style>
